module.exports = __webpack_public_path__ + "static/media/beehive-02.85decb94.png";